<template>
  <div class="container">
    <div class="loading" v-if="loading">
      <a-spin tip="Loading..." size="large"></a-spin>
    </div>
    <slot v-else />
  </div>
</template>

<script>
import firebase from 'firebase/app';

export default {
  data() {
    return {
      loading: true,
    };
  },
  beforeCreate() {
    const cb = firebase.auth().onAuthStateChanged(() => {
      this.loading = false;
      cb();
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';

.container {
  display: flex;
  flex: 1;
}

.loading {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: $background-blue;
}
</style>

<style lang="scss">
.loading {
  .ant-spin-dot {
    height: 3em;
    width: 3em;

    i.ant-spin-dot-item {
      height: 40px;
      width: 40px;
    }
  }

  .ant-spin-text {
    font-size: 24px;
  }
}
</style>
